/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'error': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" _fill="#333" d="M845.9 943L512.2 608.9 178.4 943c-26.3 26.4-69 26.4-95.4 0-26.3-26.4-26.3-69.1 0-95.4l333.8-334.1L83 179.4C56.7 153 56.7 110.3 83 84c26.3-26.4 69-26.4 95.4 0l333.8 334L845.9 84c26.3-26.4 69-26.4 95.4 0 26.3 26.4 26.3 69.1 0 95.4L607.5 513.5l333.8 334.1c26.3 26.4 26.3 69.1 0 95.4-26.4 26.3-69.1 26.3-95.4 0z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/error.js